/**
 * Token persistence.
 *
 * localStorage, deliberately: agents keep a tab open across a working day and
 * expect to stay signed in, and the same code has to work in the mobile
 * WebView where cookies are awkward. The trade-off is that a successful XSS
 * could read the tokens — which is why the app renders no user-supplied HTML
 * anywhere, and why refresh tokens rotate on every use so a stolen one is
 * short-lived and its use is detectable server-side.
 */
const ACCESS_KEY = 'tharanga.accessToken';
const REFRESH_KEY = 'tharanga.refreshToken';
const DEVICE_KEY = 'tharanga.deviceId';

export const tokenStore = {
  getAccess(): string | null {
    return localStorage.getItem(ACCESS_KEY);
  },

  getRefresh(): string | null {
    return localStorage.getItem(REFRESH_KEY);
  },

  set(accessToken: string, refreshToken: string): void {
    localStorage.setItem(ACCESS_KEY, accessToken);
    localStorage.setItem(REFRESH_KEY, refreshToken);
  },

  clear(): void {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
  },

  /**
   * A stable per-install id. The server ties one live session to it, so
   * signing in again from the same browser retires the previous session
   * instead of leaving orphaned ones an admin cannot identify.
   */
  deviceId(): string {
    let id = localStorage.getItem(DEVICE_KEY);
    if (!id) {
      id = `web-${Math.random().toString(36).slice(2, 10)}-${Date.now().toString(36)}`;
      localStorage.setItem(DEVICE_KEY, id);
    }
    return id;
  },
};
